// Dados estáticos para demo sem backend.

export const DEMO_PRODUCTS = [
  {
    id: "vestido-seda-01",
    name: "Vestido de Seda Fluida",
    description: "Corte fluido em seda natural, ideal para ocasiões especiais. Caimento elegante e leve.",
    price: 890,
    category: "Vestidos",
    images: [
      "https://images.unsplash.com/photo-1664076458686-3449062080ac?w=800&q=80",
      "https://images.unsplash.com/flagged/photo-1553277004-39d655b57262?w=800&q=80",
    ],
    sizes: ["P", "M", "G"],
    colors: ["Champagne", "Preto"],
    stock: 12,
    featured: true,
  },
  {
    id: "blazer-alfaiataria-01",
    name: "Blazer Alfaiataria",
    description: "Blazer estruturado com ombros definidos e forro acetinado. Peça coringa do guarda-roupa.",
    price: 1290,
    category: "Blazers",
    images: [
      "https://images.unsplash.com/photo-1608234808654-2a8875faa7fd?w=800&q=80",
      "https://images.unsplash.com/photo-1593030942428-a5451dca4b42?w=800&q=80",
    ],
    sizes: ["P", "M", "G", "GG"],
    colors: ["Creme", "Preto", "Camel"],
    stock: 8,
    featured: true,
  },
  {
    id: "trico-cashmere-01",
    name: "Tricô Cashmere",
    description: "Tricô macio em mistura de cashmere. Textura rica e silhueta relaxada.",
    price: 690,
    category: "Tricô",
    images: [
      "https://images.unsplash.com/photo-1574201635302-388dd92a4c3f?w=800&q=80",
      "https://images.unsplash.com/photo-1608984361471-ff566593088f?w=800&q=80",
    ],
    sizes: ["Único"],
    colors: ["Off-white", "Cinza"],
    stock: 15,
    featured: true,
  },
  {
    id: "camisa-linho-01",
    name: "Camisa de Linho",
    description: "Camisa em linho europeu com botões em madrepérola. Fresca e atemporal.",
    price: 480,
    category: "Camisas",
    images: [
      "https://images.unsplash.com/photo-1608234807905-4466023792f5?w=800&q=80",
      "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?w=800&q=80",
    ],
    sizes: ["P", "M", "G"],
    colors: ["Branco", "Areia"],
    stock: 20,
    featured: false,
  },
  {
    id: "calca-reta-01",
    name: "Calça Reta Minimal",
    description: "Calça de alfaiataria com cós alto e perna reta. Acabamento impecável.",
    price: 750,
    category: "Calças",
    images: [
      "https://images.unsplash.com/photo-1694447814836-c93ab70f7398?w=800&q=80",
      "https://images.unsplash.com/photo-1608234808654-2a8875faa7fd?w=800&q=80",
    ],
    sizes: ["36", "38", "40", "42"],
    colors: ["Preto", "Marinho"],
    stock: 10,
    featured: true,
  },
  {
    id: "vestido-midi-01",
    name: "Vestido Midi Editorial",
    description: "Vestido midi com drapeado sutil e tecido de toque sedoso. Peça de campanha.",
    price: 980,
    category: "Vestidos",
    images: [
      "https://images.unsplash.com/photo-1662532577856-e8ee8b138a8b?w=800&q=80",
      "https://images.unsplash.com/photo-1645561305502-63a9ba09ab09?w=800&q=80",
    ],
    sizes: ["P", "M", "G"],
    colors: ["Terracota", "Preto"],
    stock: 6,
    featured: false,
  },
  {
    id: "blazer-oversized-01",
    name: "Blazer Oversized",
    description: "Silhueta oversized com lapela larga. Ideal para looks contemporâneos.",
    price: 1180,
    category: "Blazers",
    images: [
      "https://images.unsplash.com/photo-1593030942428-a5451dca4b42?w=800&q=80",
      "https://images.unsplash.com/photo-1608234808654-2a8875faa7fd?w=800&q=80",
    ],
    sizes: ["P", "M", "G"],
    colors: ["Cinza", "Preto"],
    stock: 7,
    featured: false,
  },
  {
    id: "trico-gola-01",
    name: "Tricô Gola Alta",
    description: "Gola alta em ponto fino, perfeito para camadas no inverno.",
    price: 520,
    category: "Tricô",
    images: [
      "https://images.unsplash.com/photo-1608984361471-ff566593088f?w=800&q=80",
      "https://images.unsplash.com/photo-1574201635302-388dd92a4c3f?w=800&q=80",
    ],
    sizes: ["P", "M", "G"],
    colors: ["Preto", "Creme"],
    stock: 14,
    featured: false,
  },
];

export function filterDemoProducts({ category, search, featured } = {}) {
  let list = [...DEMO_PRODUCTS];
  if (featured === true || featured === "true") list = list.filter((p) => p.featured);
  if (category && category !== "all") list = list.filter((p) => p.category === category);
  if (search) {
    const q = String(search).toLowerCase();
    list = list.filter(
      (p) =>
        p.name.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q) ||
        p.description.toLowerCase().includes(q)
    );
  }
  return list;
}

export function getDemoCategories() {
  return [...new Set(DEMO_PRODUCTS.map((p) => p.category))];
}

export function getDemoProduct(id) {
  return DEMO_PRODUCTS.find((p) => p.id === id) || null;
}
